import React, { useEffect, useState } from 'react';
import { RequestDataSetting, updateSettingChat } from 'api/chat/setting/update-setting';
import { useSubscription } from 'hooks/use-subscription.hook';

interface IChatProps {
  self: RequestDataSetting;
}
function Chat({ self }: IChatProps) {
  const subscription = useSubscription();
  const [statusActive, setStatusActive] = useState({
    is_active_status: self.is_active_status,
    isCheckChangeContent: false,
  });

  useEffect(() => {
    if (!statusActive.isCheckChangeContent) return;

    const chatSettingSub = updateSettingChat(self._id, { is_active_status: statusActive.is_active_status }).subscribe();

    subscription.add(chatSettingSub);
  }, [statusActive, subscription, self._id]);

  return (
    <div className='tab-item'>
      <li className='list-group-item'>
        Active status
        <label className='switch'>
          <input
            type='checkbox'
            className='success'
            checked={statusActive.is_active_status}
            onChange={() =>
              setStatusActive({ is_active_status: !statusActive.is_active_status, isCheckChangeContent: true })
            }
          />
          <span className='slider round'></span>
        </label>
      </li>
    </div>
  );
}

export default Chat;
